import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export class AppFormItemFileUploadMixin extends Vue {
  @Prop()
  public accept!: string;

  @Prop()
  public acceptedMimeTypes!: string;

  @Prop()
  public maxSize!: number;

  @Prop()
  public multiple!: boolean;

  @Prop()
  public maximum!: number;

  @Prop()
  public buttonClass!: string;

  public get resolvedMultiple(): boolean {
    return !!this.multiple && this.maximum !== 1;
  }
}
